<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>{{ __("Die Auktion auf cropspot") }}</span>
		</template>
		<template v-slot:content>
			<div >
				<img :src="headerImageUrl" class="inline" />
			</div>
			<div class="p-6">
				<div class="sm:flex sm:items-start">
					<div class="mt-4 text-center sm:mt-0 sm:ml-4 sm:text-left">
						<h3 class="text-3xl text-center font-bold text-center my-5 md:px-8">
							Mit unserer Auktion bringen wir Käufer und Verkäufer schnell und effizienten zusammen!
						</h3>
						<img :src="auctionHammerUrl" class="inline" />
						<h3 class="text-2xl text-orange font-bold my-8 ml-2 inline">
							So läuft unsere Auktion ab
						</h3>
						<ol class="relative mt-4">
							<li
								class="pb-4 border-l-4 border-orange pl-12"
								style="margin-left: 27px"
							>
								<span
									class="flex absolute justify-center items-center bg-orange rounded-full left-4"
									style="width: 30px; height: 30px"
								>
									<span
										class="bg-white rounded-full text-orange text-2xl text-center font-bold"
										style="width: 28px; height: 28px"
										>1</span
									>
								</span>
								<div class="bg-gray-100 p-5 rounded-xl shadow">
									<h3
										class="mb-2 text-lg font-semibold text-gray-900 leading-4"
									>
										Bereitstellen
									</h3>
									<p class="pb-2 text-base font-normal">
										Jede Woche Mittwoch und Donnerstag ist bei cropspot Auktionstag! Sie haben die Möglichkeit, Ihre Ware aus Ihrem Inserat bis spätestens 14:30 Uhr am Auktionstag anzumelden und zu platzieren. Gleichzeitig legen Sie einen Zielpreis fest, zu welchem Sie verbindlich bereit wären, Ihre Ware zu verkaufen. Ihre Eingaben können Sie bis zur Auktionseröffnung jederzeit ändern oder löschen.
									</p>
								</div>
							</li>
							<li
								class="pb-4 border-l-4 border-orange pl-12"
								style="margin-left: 27px"
							>
								<span
									class="flex absolute justify-center items-center bg-orange rounded-full left-4"
									style="width: 30px; height: 30px"
								>
									<span
										class="bg-white rounded-full text-orange text-2xl text-center font-bold"
										style="width: 28px; height: 28px"
										>2</span
									>
								</span>
								<div class="bg-gray-100 p-5 rounded-xl shadow">
									<h3
										class="mb-2 text-lg font-semibold text-gray-900 leading-4"
									>
										Auktionseröffnung
									</h3>
									<p class="pb-2 text-base font-normal">
										Um 14:30 Uhr wird unsere Auktion eröffnet. Geprüfte sowie verifizierte Käufer können sich bis 15:00 Uhr einen unverbindlichen Überblick über alle Auktionsangebote verschaffen. Der von Ihnen gesetzte Zielpreis ist dabei bis zum Ende der Auktion verdeckt.
									</p>
								</div>
							</li>
							<li
								class="pb-4 border-l-4 border-orange pl-12"
								style="margin-left: 27px"
							>
								<span
									class="flex absolute justify-center items-center bg-orange rounded-full left-4"
									style="width: 30px; height: 30px"
								>
									<span
										class="bg-white rounded-full text-orange text-2xl text-center font-bold"
										style="width: 28px; height: 28px"
										>3</span
									>
								</span>
								<div class="bg-gray-100 p-5 rounded-xl shadow">
									<h3
										class="mb-2 text-lg font-semibold text-gray-900 leading-4"
									>
										Bietphase
									</h3>
									<p class="pb-2 text-base font-normal">
										Ab 15:00 Uhr beginnt die Bietphase für Käufer. In dieser Phase können Interessenten verdeckt auf die angebotenen Waren bieten. Jeder Bieter gibt ein Gebot ab, ohne zu wissen, wie viel andere geboten haben.
									</p>
								</div>
							</li>
							<li
								class="pb-4 border-l-4 border-orange pl-12"
								style="margin-left: 27px"
							>
								<span
									class="flex absolute justify-center items-center bg-orange rounded-full left-4"
									style="width: 30px; height: 30px"
								>
									<span
										class="bg-white rounded-full text-orange text-2xl text-center font-bold"
										style="width: 28px; height: 28px"
										>4</span
									>
								</span>
								<div class="bg-gray-100 p-5 rounded-xl shadow">
									<h3
										class="mb-2 text-lg font-semibold text-gray-900 leading-4"
									>
										Auktionsende
									</h3>
									<p class="pb-2 text-base font-normal">
										Nach Ende der Bietphase um 16:00 Uhr entscheidet das höchste Gebot über den Zuschlag. Für Sie können sich folgende Ergebnisse ergeben:
									</p>
									<p class="pb-2 text-base font-normal">
										<strong>a)</strong> Wenn ein Käufer mindestens Ihren Zielpreis bietet, kommt es automatisch zu einem verbindlichen Kontrakt.
									</p>
									<p class="pb-2 text-base font-normal text-gray-400">
										<strong class="text-gray-500">Beispiel:</strong> Ihr Zielpreis war für 50 Tonnen 230 €/t ab Hof und ein Händler hat in der Auktion als Höchstbietender 232 €/t geboten. Nach Ende der Auktion wird auf cropspot automatisch ein Kontrakt zu dem vom Händler gebotenen Preis, in dem Fall 232 €/t, geschlossen.
									</p>
									<p class="pb-2 text-base font-normal">
										<strong>b)</strong> Wenn kein Käufer mindestens Ihren Zielpreis bietet, erhalten Sie zum Ende der Auktion ein Gebot in den cropspot-Verhandlungen mit dem Preis des Höchstbietenden. Sollte Ihr Zielpreis zu weit vom Marktpreis entfernt sein, haben Sie hier die Möglichkeit noch einmal in Verhandlungen zu treten.
									</p>
									<p class="pb-2 text-base font-normal text-gray-400">
										<strong class="text-gray-500">Beispiel:</strong> Ihr Zielpreis war für 50 Tonnen 230 €/t ab Hof. Der höchste Preis für Ihr Angebot war 228 €/t.  Sie erhalten nun lediglich von diesem Käufer ein 30 Minuten gültiges Angebot auf cropspot mit dem Preis von 228 €/t. Die Entscheidung, ob Sie das Angebot annehmen, ablehnen oder einen anderen Preis verhandeln, liegt bei Ihnen.
									</p>
								</div>
							</li>
							<li
								class="pb-4 border-l-4 border-white pl-12"
								style="margin-left: 27px"
							>
								<span
									class="flex absolute justify-center items-center bg-orange rounded-full left-4"
									style="width: 30px; height: 30px"
								>
									<span
										class="bg-white rounded-full text-orange text-2xl text-center font-bold"
										style="width: 28px; height: 28px"
										>?</span
									>
								</span>
								<div class="bg-gray-100 p-5 rounded-xl shadow">
									<h3
										class="mb-2 text-lg font-semibold text-gray-900 leading-4"
									>
										Weitere Fragen? Kontaktieren Sie uns und wir unterstützen
										Sie gern bei Ihrer Auktion!
									</h3>
									<div class="flex justify-start items-center pr-4 pt-2">
										<img
											class="w-16 h-16 rounded-full lg:w-20 lg:h-20"
											:src="auctionThumbUrl"
										/>

										<div class="font-medium ml-6 space-y-1">
											<h3 class="text-gray-900 text-lg">
												Maximilian von Weichs
											</h3>
											<p class="text-gray-700">+49 (0) 172 1011 622</p>
											<a
												href="mailto:m.weichs@cropspot.com"
												class="text-orange-500"
												>m.weichs@cropspot.com</a
											>
										</div>
									</div>
								</div>
							</li>
						</ol>
					</div>
				</div>
			</div>
			<div class="bg-gray-100 p-6 flex justify-end">
				<div>
					<ui-button
						type="primary"
						v-on:click="close()"
						label="zurück"
					></ui-button>
				</div>
			</div>
		</template>
	</ui-modal-template>
</template>

<script>
export default {
	data() {
		return {
			open: false,
		};
	},
	mounted() {
		this.open = true;
	},
	computed: {
		headerImageUrl: () => window.baseUrl + "/images/auction-info-header.png",
		//getBoxBackgroundCSS: () => "background:url(" + window.baseUrl + "/images/auction-info-bubble-bg.svg) bottom right no-repeat;",
		auctionHammerUrl() {
			return window.baseUrl + "/images/auction-hammer-orange.svg";
		},
		auctionThumbUrl() {
			return window.baseUrl + "/images/max-rounded.jpg";
		},
	},
	methods: {
		close() {
			this.$bus.$emit("modal:close");
		},
		getBoxBackgroundCSS(color = "") {
			return (
				"background:url(" +
				window.baseUrl +
				"/images/auction-info-bubble-bg" +
				(color !== "" ? "-" + color : "") +
				".svg) bottom right no-repeat;"
			);
		},
	},
};
</script>
